import {Grid} from "@mui/material";
import React from "react";
import PageGridPlacement from "../layouts/body/PageGridPlacement";
import {PageGridPlacement as CmPageGridPlacement} from "../../../packages/graphql-layer/src";
import P011Publication from "../doctypes/P011Publication/P011Publication";
import P015Cart from "../doctypes/cart/P015Cart";
import dynamic from "next/dynamic";
import {isWimmelbild} from "./pageLayoutsUtils";
import useWindowSize from "../../utility/useWindowSize";

interface Props {
    navigation: any,
    page: any,
    content?: any,
    CAEGlobalSettings: any,
    children?: JSX.Element,
    currentURL: string,
    csrfToken: string,
    credentials: any
}
const P010Wimmelbild = dynamic(() => import('../doctypes/P010Wimmelbild'), {
    ssr: false,
});


function BlankPageLayout(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize()
    const navHeight = {
        height: greaterThanWindowMedium ? '12rem' : '4rem'
    };
    const isPublication = props.content?.content?.content?.type === "SOSPublication"
    const isCart = props.currentURL.endsWith("warenkorb")
    return <>
        <Grid container
              direction="column"
              justifyContent="center"
              alignItems="stretch"
              spacing={1}>
            <Grid item pt={'0!important'}>
                {props.page && isWimmelbild(props.page) ? <P010Wimmelbild wimmelbild={props.page}/> : ""}
                {isPublication ?
                    <P011Publication sosPublication={props.content.content?.content}
                                     backUri={props.page?.selfUrl}/> : ''}
                {isCart ?
                    <P015Cart/> : ""}
                {
                    props.page.grid.placements.map((p: CmPageGridPlacement, index: number) => renderPlacements(p, index, props.CAEGlobalSettings, props.csrfToken, props.credentials))
                }
            </Grid>
        </Grid>
    </>
}

function renderPlacements(placement: CmPageGridPlacement, index: number, CAEGlobalSettings: any, csrfToken: string, credentials: any) {
    switch (placement.name) {
        case "header": {
            return null
        }
        case "footer": {
            return null
        }
        default: {
            return <PageGridPlacement placementName={placement.name} key={index} items={placement.items} viewtype={placement.viewtype || ''}
                                      CAEGlobalSettings={CAEGlobalSettings} csrfToken={csrfToken} credentials={credentials}/>
        }
    }
}

export default BlankPageLayout